import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FiGrid, FiUsers, FiBell } from 'react-icons/fi';
import { BsList, BsDot, BsListTask, BsChevronDown, BsBell, BsPeopleCircle } from 'react-icons/bs';
import { useTranslation } from "react-i18next";
import * as userAuthActions from '../../Redux/Actions/user';
import {toastMessage} from '../../utils/toast';
import JobRequest from './jobRequest';
import {  Pill } from 'evergreen-ui'
import * as notificationActions from "../../Redux/Actions/notifications";
import { reset } from '../../Redux/Reducers/jobFilter';

const SideNav = ({children, history}) => {
    const [selectedCategory, setSelectedCategory] = useState('dashboard');
    const [showMenu, setShowMenu] = useState((window.innerWidth > 1050) ? false : true);
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [isArabic, setIsArabic] = useState(localStorage.getItem('i18nextLng') === 'arabic');
    const dispatch = useDispatch();
    const pathName = window.location.pathname;
    const userData = useSelector(({User}) => User.data);
    const { t, i18n } = useTranslation();
    const [unReadNotificationCount,setUnReadNotificationCount] = useState(0);
    const [unreadNotificationCall, setUnreadNotificationCall] = useState();
    
    const NotificationFetchIntervlInMilliSeconds = 300000;

    useEffect(()=> {
        handleUnreadNotificationCount();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
        handleUnreadNotificationCount();
    }, NotificationFetchIntervlInMilliSeconds);

    return () => clearInterval(interval); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[unreadNotificationCall]);

    
    useEffect(() => {
        if((pathName === '/staff') || (pathName === '/staff/add')){
            setSelectedCategory('staff');
        }
        askNotificationPermission();
    }, [pathName]);

    const askNotificationPermission = () => {
        const handlePermission = (permission) => {
            if(!('permission' in Notification)) {
                Notification.permission = permission;
            }
            console.log('Notification Permission', permission);
        };
    
        Notification.requestPermission(permission => {
            handlePermission(permission);
        });
    };

    const handleUnreadNotificationCount = () => {
        let d = new Date();
        if(d < unreadNotificationCall) {
            return;
        }
        setUnreadNotificationCall(d.setSeconds(d.getSeconds() + 10));
        notificationActions.getUnreadNotificationCount().then(({ data }) => {
            if (data) {
                setUnReadNotificationCount(data);
            }
            })
            .catch((err) => {
            toastMessage(
                "error",
                (err && err.message) || `Unable to get Notifications`
            );
            });
    }

    const handleUserLogout = () => {
        setShowUserMenu(false);
        dispatch(reset());
        userAuthActions.userLogout({Id: userData.UserId}).then(res => {
            if(res.status === 200){
                dispatch(userAuthActions.userAuthLogout());
                localStorage.removeItem('jwt');
                history.push('/');
            }else{
                toastMessage('error', 'Logout Failed');
            }
        }).catch(err => {
            dispatch(userAuthActions.userAuthLogout());
            localStorage.removeItem('jwt');
            history.push('/');
        });
    };

    const changeLanguage = (value) => {
        setIsArabic(value);
        i18n.changeLanguage(value ? 'arabic' : 'english');
    };

    return(
        <div style={{width: '100vw'}}>
            <div className="left-sidenav"  style={{display: (showMenu && 'none')}}>
                <div className="brand">
                    <img src={'/Assets/aamer_logo.jpg'} alt="Logo" className="logo logo-lg" style={{width: '150px', height: 'auto'}} />
                </div>
                <div className="menu-content h-100">
                    <ul className="metismenu left-sidenav-menu">
                        <li onClick={() => {history.push('/dashboard'); setSelectedCategory('dashboard'); handleUnreadNotificationCount();}}>
                            <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/dashboard') && 'text-info')}> 
                                <FiGrid className="font-20 me-lg-2" /><span>{t("sideNav.dashboard")}</span>
                            </p>
                        </li>
                        <li onClick={() => {history.push('/notifications'); setSelectedCategory('notifications'); handleUnreadNotificationCount();}}>
                            <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/notifications') && 'text-info')}> 
                                <FiBell className="font-20 me-lg-2" /><span>{t("sideNav.notifications")}    { unReadNotificationCount>0 && <Pill color="blue">{unReadNotificationCount}</Pill>}                               
                                </span>
                            </p>
                        </li>
                       {(userData.Role !== 'TYPINGCENTERSTAFF') && <li onClick={() => {setSelectedCategory('staff'); handleUnreadNotificationCount()}}>
                            <div className={"c-pointer my-4 d-flex align-items-center justify-content-between " + ((pathName === '/staff') && 'text-info')}>
                                <p><FiUsers className="font-20 me-lg-2" /><span>{t("sideNav.staffManagement.title")}</span></p>
                                <BsChevronDown />
                            </div>
                            {(selectedCategory === 'staff') && <ul className="nav-second-level">
                                <li className={"c-pointer nav-link mt-lg-n2 " + (pathName === '/staff/add' && 'active')} onClick={() => {history.push('/staff/add')}}><BsDot />{t("sideNav.staffManagement.add")}</li>
                                <li className={"c-pointer nav-link " + (pathName === '/staff' && 'active')} onClick={() => {history.push('/staff')}}><BsDot />{t("sideNav.staffManagement.manage")}</li>
                            </ul>}
                        </li>}
                        <li onClick={() => {history.push('/jobs'); setSelectedCategory('jobs'); handleUnreadNotificationCount() }}>
                            <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/jobs') && 'text-info')}>
                                <span><BsListTask className="font-20 me-lg-2" /><span>{t("sideNav.jobManagement")}</span></span>
                            </p>
                        </li>
                        {/* <li onClick={() => {history.push('/reports'); setSelectedCategory('reports'); handleUnreadNotificationCount()}}>
                            <p className={"c-pointer my-4 d-flex align-items-center " + ((pathName === '/reports') && 'text-info')}>
                                <BsClipboardData className="font-20  me-lg-2" /><span>{t("sideNav.reports")}</span>
                            </p>
                        </li> */}
                    </ul>
                </div>
            </div>

            <div className="page-wrapper" style={{margin: (showMenu && 0)}}>
                <div className="topbar">
                    <nav className="navbar-custom">
                        <ul className="list-unstyled topbar-nav float-end mb-0 d-flex align-items-center">
                            <li className="form-switch form-switch-secondary">
                                <input className="form-check-input" type="checkbox" id="customSwitchSecondary" checked={isArabic} onChange={e => changeLanguage(e.target.checked)} />
                                <label className="form-check-label text-white ps-2 pe-3" htmlFor="customSwitchSecondary">Arabic</label>
                            </li>

                            <li onClick={() => {history.push('/notifications'); setSelectedCategory('notifications')}} className="dropdown notification-list">
                                <p className="nav-link dropdown-toggle arrow-none waves-light waves-effect">
                                    <BsBell className="font-20" />
                                </p>
                            </li>

                            <li className="dropdown">
                                <p className="nav-link dropdown-toggle waves-effect waves-light nav-user" onClick={() => setShowUserMenu(!showUserMenu)}>
                                    <span className="me-2 nav-user-name">{userData.Name}</span>
                                    <BsPeopleCircle className="font-20" />
                                </p>
                                <div className={"dropdown-menu dropdown-menu-end " + (showUserMenu ? "show" : "")} style={{right: '5px'}}>
                                    <p className="dropdown-item c-pointer" onClick={() => {history.push('/change-password'); setShowUserMenu(false)}}>{t("profile.changePassword")}</p>
                                    <p className="dropdown-item c-pointer" onClick={handleUserLogout}>{t("profile.logout")}</p>
                                </div>
                            </li>
                        </ul>

                        <ul className="list-unstyled topbar-nav mb-0">
                            <li>
                                <button className="nav-link button-menu-mobile" onClick={() => setShowMenu(!showMenu)}>
                                    <BsList className="font-20" />
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div className="page-content">
                    {children}
                    <footer className="footer text-center text-sm-start">&copy; Aamer</footer>
                </div>
            </div>
            <JobRequest history={history} userID={userData.UserId} />
        </div>
    );
};

export default SideNav;